import React from 'react';
import { Filter, Star } from 'lucide-react';
interface ReviewFiltersProps {
  sortBy: string;
  onSortChange: (sort: string) => void;
  filterByRating: number | null;
  onRatingFilterChange: (rating: number | null) => void;
  showVerifiedOnly: boolean;
  onVerifiedToggle: () => void;
}
export function ReviewFilters({
  sortBy,
  onSortChange,
  filterByRating,
  onRatingFilterChange,
  showVerifiedOnly,
  onVerifiedToggle
}: ReviewFiltersProps) {
  return <div className="bg-white border border-gray-300 p-4 flex flex-wrap items-center gap-4" data-id="element-1040">
      <div className="flex items-center gap-2" data-id="element-1041">
        <Filter className="w-4 h-4 text-gray-500" data-id="element-1042" />
        <span className="text-sm font-bold text-gray-700" data-id="element-1043">Filter & Sort:</span>
      </div>

      {/* Sort By */}
      <select value={sortBy} onChange={e => onSortChange(e.target.value)} className="px-3 py-1.5 border border-gray-300 bg-gray-50 text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-1044">
        <option value="newest" data-id="element-1045">Newest First</option>
        <option value="highest" data-id="element-1046">Highest Rating</option>
        <option value="lowest" data-id="element-1047">Lowest Rating</option>
        <option value="helpful" data-id="element-1048">Most Helpful</option>
      </select>

      {/* Rating Filter */}
      <div className="flex items-center gap-2" data-id="element-1049">
        <span className="text-xs text-gray-500" data-id="element-1050">Rating:</span>
        <div className="flex gap-1" data-id="element-1051">
          {[5, 4, 3, 2, 1].map(rating => <button key={rating} onClick={() => onRatingFilterChange(filterByRating === rating ? null : rating)} className={`px-2 py-1 border text-xs font-medium ${filterByRating === rating ? 'border-[#1f2933] bg-gray-50' : 'border-gray-300 hover:bg-gray-50'}`} data-id="element-1052">
              {rating}★
            </button>)}
          <button onClick={() => onRatingFilterChange(null)} className={`px-2 py-1 border text-xs font-medium ${filterByRating === null ? 'border-[#1f2933] bg-gray-50' : 'border-gray-300 hover:bg-gray-50'}`} data-id="element-1053">
            All
          </button>
        </div>
      </div>

      {/* Verified Only Toggle */}
      <label className="flex items-center gap-2 cursor-pointer" data-id="element-1054">
        <input type="checkbox" checked={showVerifiedOnly} onChange={onVerifiedToggle} className="w-4 h-4" data-id="element-1055" />
        <span className="text-xs text-gray-700" data-id="element-1056">Verified Purchases Only</span>
      </label>
    </div>;
}